import Image from "next/image";

const AboutAreaOne = ({ className }: { className?: string }) => {
  return (
    <div className={`about-us-area position-relative z-1 ptb-120 ${className}`}>
      <div className="container">
        <div
          className="row align-items-center"
         
        >
          <div className="col-lg-6 col-md-12">
            <div className="about-us-image text-center">
              <Image
                width={618}
                height={608}
                sizes="100vw"
                src="/images/about-us/a1.jpg"
                alt="about-image"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="about-us-content">
              <div className="video-box position-relative">
                <Image
                  width={800}
                  height={147}
                  sizes="100vw"
                  src="/images/about-us/a2.jpg"
                  alt="about-image"
                />
                <div className="content">
                  <div>
                    <span className="d-block fw-medium">Play Video</span>
                    <p>How We Teach Our Students</p>
                  </div>
                  {/* <ModalVideo> */}
                    <a href="#" className="video-btn popup-youtube rounded-circle d-flex align-items-center justify-content-center">
                      <Image
                        width={25}
                        height={35}
                        sizes="100vw"
                        src="/images/icons/play2.svg"
                        alt="play"
                      />
                    </a>
                  {/* </ModalVideo> */}
                </div>
              </div>
              <h2 className="fw-semibold text-uppercase fs-3">
                About Us

              </h2>
              <p className="fs-6 justify-clean">
                  Ashva Education and Para-medical Organization is Academic Organization Established in the year 2013, mainly deals in promotion of Vocational and Professional and Paramedical Educational programs for the deprived and deserving candidates in the society.
              </p>
              <p className="fs-6 justify-clean">
                  Besides Organization works for the upliftment of the people from under-privileged class through developmental work of distinct nature which includes arranging Health and Medical checkup camps for un-served and under-served people through door-steps services, arranging blood Donation camps, Career guidance classes for SSC and HSC passed out students etc.
              </p>
              
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-down-text text-uppercase d-flex align-items-center">
        <div>
          <Image
            width={24}
            height={24}
            src="/images/icons/bx-mouse.svg"
            alt="bx-mouse"
          />
          Scroll Down
        </div>
      </div>
    </div>
  );
};

export default AboutAreaOne;
